export default function Story() {
  return (
    <section className="py-16 md:py-24 bg-[#F8F8F8]">
      <div className="max-w-[1000px] mx-auto px-5 md:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#B8985F]/40 bg-[#B8985F]/10 mb-6">
            <i className="ri-book-open-line text-[#B8985F] text-sm w-4 h-4 flex items-center justify-center"></i>
            <span className="text-[13px] text-[#B8985F] font-medium">Our Story</span>
          </div>
          <h2 className="text-[36px] md:text-[42px] font-bold text-black leading-[1.2] mb-6">
            How We Started
          </h2>
        </div>

        <div className="space-y-8">
          <div className="bg-white rounded-lg p-8 md:p-10 shadow-sm">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 rounded-full bg-[#B8985F]/20 flex items-center justify-center flex-shrink-0">
                <i className="ri-lightbulb-line text-[#B8985F] text-xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="text-[22px] md:text-[26px] font-bold text-black mb-3">The Problem</h3>
                <p className="text-[15px] md:text-[17px] text-[#555] leading-[1.7]">
                  We noticed that growing companies were facing the same challenge: as their customer base expanded, support tickets multiplied exponentially. Hiring more agents was expensive and slow, while customers expected faster responses than ever before.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-8 md:p-10 shadow-sm">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 rounded-full bg-[#B8985F]/20 flex items-center justify-center flex-shrink-0">
                <i className="ri-tools-line text-[#B8985F] text-xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="text-[22px] md:text-[26px] font-bold text-black mb-3">The Solution</h3>
                <p className="text-[15px] md:text-[17px] text-[#555] leading-[1.7]">
                  We built EasyMarketPro to bridge this gap. Our AI agents are trained on real support operations, understanding context, tone, and urgency. They resolve common issues instantly while intelligently escalating complex cases to human agents.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-8 md:p-10 shadow-sm">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 rounded-full bg-[#B8985F]/20 flex items-center justify-center flex-shrink-0">
                <i className="ri-line-chart-line text-[#B8985F] text-xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="text-[22px] md:text-[26px] font-bold text-black mb-3">The Impact</h3>
                <p className="text-[15px] md:text-[17px] text-[#555] leading-[1.7]">
                  Today, we help businesses reduce ticket volume by up to 60%, cut response times from hours to seconds, and maintain high customer satisfaction—all without increasing headcount. Our clients save thousands in operational costs while delivering better support experiences.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
